import './social-media.component.less'

export default function socialMediaComponent (BulkApplyService, SocialMediaService, SceneCollectionService) {
  'ngInject'
  return {
    restrict: 'E',
    scope: {},
    bindToController: {
      scene: '=?'
    },
    controller: () => {},
    controllerAs: 'ctrl',
    template: require('./social-media.tpl.html').default,
    link: function ($scope, $element, $attrs, ctrl) {
      ctrl.isCollapsed = false
      ctrl.SocialMediaSources = SocialMediaService.getAll()

      ctrl.unsubscribe = SocialMediaService.subscribe(state => {
        ctrl.SocialMediaSources = state.SocialMediaSources
      })

      $scope.$on('$destroy', () => {
        ctrl.unsubscribe()
        BulkApplyService.destroyNamespace('socialmediasources')
      })

      ctrl.addToScene = function addSocialToScene (id) {
        SceneCollectionService.addSceneCollectionItemToSceneCollection('social', id)
      }

      ctrl.toggleBulk = function toggleBulkOnSocialMedia (id) {
        BulkApplyService.toggleElement('socialmediasources', id)
      }

      ctrl.isSceneActive = function () {
        return !!SceneCollectionService.activeSceneCollectionId
      }
    }
  }
}
